import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../../../Api/ApiClient";
import apis from "../../../Api/api.json";
import { TopHeader } from "../TopHeader/TopHeader";
import { CmsFooter } from "../Footer/CmsFooter";
import CmsDisplay from "./CmsDisplay";

const PublicGalleryList = () => {
  const [galleryList, setGalleryList] = useState([]);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const response = await apiClient.get(apis.getgallerylist);
      setGalleryList(response.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <TopHeader />

      <div id="main-content">
        <CmsDisplay />

        <div className="container main-sec">
          <section className="news-section-box">
            <h3 className="m-4 text-center">Gallery</h3>

            <ul>
              {galleryList.map((item) => (
                <li
                  key={item.u_id}
                  className="border-bottom border-success p-2 m-2"
                >
                  <div className="newsbox">
                    <p className="news-p">
                      <Link to={`/gallery/${item.u_id}`}>
                        {item.u_title}
                      </Link>
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        </div>

        <CmsFooter />
      </div>
    </>
  );
};

export default PublicGalleryList;